import { ReactNode, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectSelectedTake3D,
  selectTakes3D,
} from "../../../app/slices/TrainingSlice";
import {
  getTakeSetupPlan,
  getTakeSetupStepPositionId,
  TakeSetupStep,
} from "../../../helpers/TakeSetupPlan";
import TakeSetupFlow from "./TakeSetupFlow";
import usePreviousTakeExit from "./usePreviousTakeExit";

/** The selected take's setup, shown in its On Take Start node. */
export default function TakeStartSetup(props: {
  triggerLabel: string;
  handle: ReactNode;
}) {
  const takes = useSelector(selectTakes3D);
  const take = useSelector(selectSelectedTake3D);
  const index = take ? takes.findIndex((candidate) => candidate.id === take.id) : -1;
  const previousTake = index > 0 ? takes[index - 1] : undefined;

  const plan = useMemo(
    () => (take ? getTakeSetupPlan(previousTake, take) : undefined),
    [previousTake, take],
  );
  const positionOf = useCallback(
    (step: TakeSetupStep) =>
      take ? getTakeSetupStepPositionId(step, previousTake, take) : undefined,
    [previousTake, take],
  );
  const previousExit = usePreviousTakeExit();

  if (!plan) return <>{props.handle}</>;
  return (
    <TakeSetupFlow
      plan={plan}
      triggerLabel={props.triggerLabel}
      handle={props.handle}
      positionOf={positionOf}
      previousExit={previousExit}
    />
  );
}
